import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Index',
    // component: Home
    component: () => import(/* webpackChunkName: "Home" */ '../views/Index.vue')
  },
  {
    path: '/開始遊戲',
    name: 'C1-1',
    component: () => import(/* webpackChunkName: "Home" */ '../views/Chapter1_1.vue'),
  },
  {
    path: '/初會面',
    name: 'C1-2',
    component: () => import(/* webpackChunkName: "Home" */ '../views/Chapter1_2.vue'),
  },
  {
    path: '/前往小逸堂',
    name: 'C1-3',
    component: () => import(/* webpackChunkName: "Home" */ '../views/Chapter1_3.vue'),
  },
  {
    path: '/2',
    name: 'C2-1',
    component: () => import(/* webpackChunkName: "Home" */ '../views/Chapter2_1.vue'),
  },
  {
    path: '/前往公會堂',
    name: 'C2-2',
    component: () => import(/* webpackChunkName: "Home" */ '../views/Chapter2_2.vue'),
  },
  {
    path: '/臺灣新文化',
    name: 'C3-1',
    component: () => import(/* webpackChunkName: "Home" */ '../views/Chapter3_1.vue'),
  },
  {
    path: '/前往孔廟',
    name: 'C3-2',
    component: () => import(/* webpackChunkName: "Home" */ '../views/Chapter3_2.vue'),
  },
  {
    path: '/四',
    name: 'C4-1',
    component: () => import(/* webpackChunkName: "Home" */ '../views/Chapter4_1.vue'),
  },
  {
    path: '/前往元清觀',
    name: 'C4-2',
    component: () => import(/* webpackChunkName: "Home" */ '../views/Chapter4_2.vue'),
  },
  {
    path: '/天井',
    name: 'C4-3',
    component: () => import(/* webpackChunkName: "Home" */ '../views/Chapter4_3.vue'),
  },
  {
    path: '/智能金錢',
    name: 'C5-1',
    component: () => import(/* webpackChunkName: "Home" */ '../views/Chapter5_1.vue'),
  },
  {
    path: '/時空警察',
    name: 'C5-2',
    component: () => import(/* webpackChunkName: "Home" */ '../views/Chapter5_2.vue'),
  },
  {
    path: '/前往彰化警察署',
    name: 'C5-3',
    component: () => import(/* webpackChunkName: "Home" */ '../views/Chapter5_3.vue'),
  },
  {
    path: '/現實',
    name: 'C6-1',
    component: () => import(/* webpackChunkName: "Home" */ '../views/Chapter6_1.vue'),
  },
  {
    path: '/前往開化寺',
    name: 'C6-2',
    component: () => import(/* webpackChunkName: "Home" */ '../views/Chapter6_2.vue'),
  },
  {
    path: '/廣佈',
    name: 'C7-1',
    component: () => import(/* webpackChunkName: "Home" */ '../views/Chapter7_1.vue'),
  },
  {
    path: '/林先生',
    name: 'C7-2',
    component: () => import(/* webpackChunkName: "Home" */ '../views/Chapter7_2.vue'),
  },
  {
    path: '/前往高賓閣',
    name: 'C7-3',
    component: () => import(/* webpackChunkName: "Home" */ '../views/Chapter7_3.vue'),
  },
  {
    path: '/警察追來了',
    name: 'C7-4',
    component: () => import(/* webpackChunkName: "Home" */ '../views/Chapter7_4.vue'),
  },
  {
    path: '/逃出高賓閣',
    name: 'C7-5',
    component: () => import(/* webpackChunkName: "Home" */ '../views/Chapter7_5.vue'),
  },
  {
    path: '/扇子',
    name: 'C7-6',
    component: () => import(/* webpackChunkName: "Home" */ '../views/Chapter7_6.vue'),
  },
  {
    path: '/第五個',
    name: 'C8-1',
    component: () => import(/* webpackChunkName: "Home" */ '../views/Chapter8_1.vue'),
  },
  {
    path: '/使用神秘晶體',
    name: 'C8-2',
    component: () => import(/* webpackChunkName: "Home" */ '../views/Chapter8_2.vue'),
  },
  {
    path: '/前往賴和紀念館',
    name: 'C8-4',
    component: () => import(/* webpackChunkName: "Home" */ '../views/Chapter8_4.vue'),
  },
  {
    path: '/勇士當為義鬥爭',
    name: 'C8-3',
    component: () => import(/* webpackChunkName: "Home" */ '../views/Chapter8_3.vue'),
  },
  {
    path: '/沒有實體名片',
    name: 'C8-no',
    component: () => import(/* webpackChunkName: "Home" */ '../views/Chapter8_NO.vue'),
  },
  {
    path: '/有實體名片',
    name: 'C8-5',
    component: () => import(/* webpackChunkName: "Home" */ '../views/Chapter8_5.vue'),
  },
  {
    path: '/診療座椅',
    name: 'C8-yes',
    component: () => import(/* webpackChunkName: "Home" */ '../views/Chapter8_YES.vue'),
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import(/* webpackChunkName: "Home" */ '../views/NotFound.vue'),
    props: true,
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
